// No-op traslation function for search

export function createSearchTranslate(
  defaultTranslations: Record<string, any>
): (key: string) => string {

  function translate(key: string): string {
    const keyPath = key.split('.')

    let defaultResult: Record<string, any> | null = defaultTranslations

    const lastKey = keyPath.pop()!
    for (const k of keyPath) {
      let fallbackResult: Record<string, any> | null = null
      const foundInFallback: any = defaultResult?.[k]
      if (foundInFallback) {
        fallbackResult = defaultResult = foundInFallback
      }
      // Put fallback into unresolved results
      if (!foundInFallback) {
        defaultResult = fallbackResult
      }
    }
    return (
      defaultResult?.[lastKey] ??
      ''
    )
  }

  return translate
}
